import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Author.css";

const Author = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chaeyeon_portrait} alt="author_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Author's word" />
      <h1 className="headtext__cormorant">Motivation</h1>

      <div className="app__author-content">
        <div className="app__author-content_quote">
          <p className="p__opensans_lower_case">
            I believe in the importance of sustainability as it is a direct
            response to the ways in which we have been living our lives, and
            poses a direct impact on how we envision our future. By researching
            the bookmaking process I have grown an immense amount of respect for
            the long-standing history of curation and craftsmanship the book
            concerns. From learning to appreciate the slowing down of
            consumption with aspects of bookmaking, exploring sustainable book
            production through a salt water based paper production system, and
            writing a story about sustainability, the goal of my project is to
            mobilize a new generation of young people to begin thinking about
            their relationship with the natural world and help become a part of
            the solution.
          </p>
        </div>
      </div>

      <div className="app__author-sign">
        <p>Chaeyeon Park</p>
        <p className="p__opensans">Author & Bookbinder</p>
      </div>
    </div>
  </div>
);

export default Author;
